export const fallbackLng = 'en'
export const languages = [fallbackLng, 'th', 'ja', 'ko', 'zh']
export const defaultNS = 'home'

export function getOptions (lng = fallbackLng, ns = defaultNS) {
  return {
    // debug: true,
    supportedLngs: languages,
    fallbackLng,
    lng,
    fallbackNS: defaultNS,
    defaultNS,
    ns
  }
}